import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import styled from 'styled-components'
import theme from '~/design'
import Modal from '~/prix/react/components/modal'

const ButtonWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  width: auto;
  outline: none;
`

const ArticleModal = styled.article`
  padding: 24px;

  h2 {
    padding: 0 0 16px 0;
    margin: 0;
  }
  h3 {
    margin: 0;
    padding: 0;
  }

  li {
    line-height: 1.5em;
  }

  ul:last-of-type {
    margin-bottom: 0;
  }
`

interface LegendsInfoProps {
  title: string
  information: () => JSX.Element
}

const LegendsInfo = ({ title, information }: LegendsInfoProps) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <ButtonWrapper onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faQuestionCircle} color={theme.colors.darkText} />
      </ButtonWrapper>
      {open && (
        <Modal isOpen={open} onClose={() => setOpen(false)}>
          <ArticleModal>
            <h2>{title}</h2>
            {information()}
          </ArticleModal>
        </Modal>
      )}
    </>
  )
}

export default LegendsInfo
